import { InjectionToken } from '@angular/core';

import { PlaceBetRequest } from '@bpos/v2/bet-placement';

import { IBetslipState } from '../../../../../base/store/state';
import { ISlip } from '../../../../bet-generation/models';
import { IBetPicks } from '../../../models';

export interface RequestStrategy {
    isActive(betSlipState: IBetslipState): boolean;
    updateRequest(request: PlaceBetRequest, betSlipState: IBetslipState, slips: ISlip[], betPicks?: IBetPicks): void;
}

export const REQUEST_STRATEGIES_INJECTION_TOKEN = new InjectionToken<RequestStrategy>('REQUEST_STRATEGIES_INJECTION_TOKEN');
